var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-comiauth_detail"},[_c('acgn-group-edit',{attrs:{"isEdit":false,"comicId":_vm.comicId}}),(true)?[_c('acgn-table-task',{attrs:{"data":_vm.eventSta,"projectId":_vm.comicId}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }